import { FC } from 'react';

import { rem, SkeletonCircle } from '@bonusly/design-system';

export const NavCircle: FC = () => <SkeletonCircle boxSize={rem(44)} />;
